import { BOOLEAN_SELECT_LIST_ITEMS, Box, Grid, Stack, pn, useElementBreakpoints } from "@compass/core";
import { CustomFilters, Select } from "components";
import {
  StudentServiceTemplateFilter as StudentServiceTemplateFilterModel,
  StudentApplicationFilterResource,
  StudentServiceTemplateFilterResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentServiceTemplateFilter = (props: {
  filter: StudentServiceTemplateFilterModel;
  setFilter: (value: StudentServiceTemplateFilterModel) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<StudentServiceTemplateFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.studentServiceTemplates.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const serviceTypeField = () => {
    const propertyName = pn<StudentServiceTemplateFilterModel>("serviceTypes");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.studentServiceTypes?.filter((x) => props.filter.serviceTypes?.includes(x.id))}
        options={resource.studentServiceTypes}
        groupBy={(option) => (option.isForParent ? "Parent" : "Student")}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.serviceTypes = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const serviceLocationField = () => {
    const propertyName = pn<StudentServiceTemplateFilterModel>("serviceLocations");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.serviceLocations?.filter((x) => props.filter.serviceLocations?.includes(x.id))}
        options={resource.serviceLocations}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.serviceLocations = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const isActiveField = () => {
    const propertyName = pn<StudentServiceTemplateFilterModel>("isActive");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={BOOLEAN_SELECT_LIST_ITEMS.find((x) => x.id === props.filter.isActive)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft!.isActive = value?.id;
            })
          )
        }
      />
    );
  };

  const serviceSubTypeField = () => {
    const propertyName = pn<StudentServiceTemplateFilterModel>("serviceSubTypes");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.studentServiceSubTypes?.filter((x) => props.filter.serviceSubTypes?.includes(x.id))}
        options={resource.studentServiceSubTypes?.filter((x) => props.filter.serviceTypes?.includes(x.serviceTypeId))}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.serviceSubTypes = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  return (
    <Stack ref={breakpointsRef} spacing="lg">
      <CustomFilters
        filters={props.filter.customFilters}
        setFilters={(filters) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.customFilters = filters;
            })
          )
        }
        properties={resource.customFilterProperties}
      />
      <Box>
        <Grid ref={breakpointsRef} container spacing="sm">
          <Grid item xs={largeFieldBreakpoints}>
            {serviceTypeField()}
          </Grid>
          <Grid item xs={largeFieldBreakpoints}>
            {serviceSubTypeField()}
          </Grid>
          <Grid item xs={largeFieldBreakpoints}>
            {serviceLocationField()}
          </Grid>
          <Grid item xs={largeFieldBreakpoints}>
            {isActiveField()}
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};
